import alertify from "alertifyjs";
import "alertifyjs/build/css/alertify.css";

export default async function createPruebaMasivo(status) {
  // const endpoint = localStorage.getItem('endpoint')

  const url = "https://api.almeraim.com/securityairbytes";

  const js = JSON.stringify(status);

  try {
    const config = { method: "POST", headers: {}, mode: "cors", body: js };
    const response = await fetch(url, config);
    const json = await response.json();

    if (json.message === "ok") {
      alertify.set("alert", "position", "bottom-right");
      alertify.set("notifier", "delay", 5.0);
    } else {
      alertify.set("alert", "position", "bottom-right");
      alertify.set("notifier", "delay", 5.0);
      alertify.error("No fue posible crear el elemento");
    }
  } catch (error) {
    console.log("Error" + error);
  }
}
